/**
 * @desc 会员中心: 获取会员所拥有的角色
 */
import { RoleEntity, MemberRoleListQuery } from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryMemberRoleListParameter = MemberRoleListQuery

const method = 'GET'
const url = '/auth/member/role/list'

export const queryMemberRoleListApi = (
  params?: QueryMemberRoleListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<RoleEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryMemberRoleListApi.method = method
queryMemberRoleListApi.url = url
